import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import withStyles from 'isomorphic-style-loader/withStyles';

import ServiceFeesForm from '../../../components/siteadmin/ServiceFeesForm';
import Loader from '../../../components/Loader';

import { withQuery } from '../../../hoc/withGraphql';

import s from './ServiceFeesSettings.css';

const ServiceFeesSettings = (props) => {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isBrowser = typeof window !== 'undefined';
    isBrowser && setLoading(false);
  }, []);

  const { data: { getServiceFees }, title } = props;
  if (loading) {
    return <Loader type={"text"} />;
  } else {
    return <ServiceFeesForm initialValues={getServiceFees} title={title} />
  }
}

ServiceFeesSettings.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getServiceFees: PropTypes.shape({
      guestType: PropTypes.string.isRequired,
      guestValue: PropTypes.number.isRequired,
      hostType: PropTypes.string.isRequired,
      hostValue: PropTypes.number.isRequired,
      currency: PropTypes.string
    }),
  })
};

export default compose(
  withStyles(s),
  withQuery(gql`
        query getServiceFees{
          getServiceFees{
              id
              guestType
              guestValue
              hostType
              hostValue
              currency
              status
          }
        }
      `, { options: { ssr: false } }),
)(ServiceFeesSettings);
